import styled from 'styled-components';
import { baseTheme } from '../../global/styles/theme';

export const Chat2Desk = styled('div')`
  position: fixed;
  top: 165px;
  right: 70px;
  width: 80px;
  height: 80px;
  cursor: pointer;

  img {
    border-radius: 50%;
    box-shadow: 0px 0px 10px #acacacff;
  }

  @media (max-width: 768px) {
    bottom: 0;
    right: 10px;
  }
`;

export const ControlsContainer = styled('div')`
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 80px;
  background-color: white;
  justify-content: center;
  align-items: center;
  border-top: 1px solid #e6e6e8;
  display: ${(props) => (props.className?.length ? `none` : `flex`)};
`;

export const ControlsContentContainer = styled('div')`
  display: grid;
  max-width: 100%;
  margin: auto;
`;

export const ControlButtonContainer = styled('div')`
  padding: 7px 9px;
  border-radius: 8px;
  background-color: ${(props) =>
    props.className?.length
      ? `${baseTheme.colors.mainLightBlue}`
      : `${baseTheme.colors.white}`};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  font-weight: 500;
  margin-right: 16px;
  color: ${(props) =>
    props.className?.length ? `${baseTheme.colors.white}` : `#686868`};
  cursor: pointer;
`;
